import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import estilos from "../../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { getAllSolicitudesACUI } from '../../../../redux/DucksUnidadInspeccion/SolicitudesUIF01Duck';
import Swal from 'sweetalert2';
import { obtenerSolicitudByIdSolicitudFC01 } from '../../../../redux/DucksUnidadInspeccion/DocumentosDuck';
import { host } from '../../../../configuraciones';
function QuickSearchToolbar() {
    return (
        <Box
            sx={{ p: 0.5, pb: 0, mb: 2, textAlign: 'left', height: 30, width: '100%', backgroundColor: 'white', textAlign: 'end' }}>
            <GridToolbarQuickFilter style={{ width: '25%', }} placeholder='Búsqueda...' />
        </Box>
    );
}
function SolicitudFC09UIComponent(props) {
    const dispatch = useDispatch();
    

    const [rows, setRows] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [total, setTotal] = React.useState(0);

    let columns = [

        {
            field: "folio", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
            headerName: "Folio", flex: .7,
        },
        {
            field: "nombre", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
            headerName: "Nombre o razon social", flex: 1,
        },
        {
            field: "socio", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
            headerName: "No. de socio", flex: .5,
        },
        /*{
            field: "eslabones", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
            headerName: "Cadena Productiva", flex: 1,
        },*/
        {
            field: "estatus", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
            headerName: "Estatus", flex: 1,
        },
        {
            field: "revisor", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
            headerName: "Revisor UI", flex: 1,
        },
        {
            field: "accion", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
            headerName: "Acciones", flex: 1,
            renderCell: (params) => {
                const inspector = params.row; // los datos de la fila
                return (
                    <>
                        <Tooltip title="Ver Solicitud">
                            <IconButton onClick={() => verSolicitud(params.row)} size="small" color="secondary" >
                                <AssignmentIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Ver escrito de comición">
                            <IconButton onClick={() => handleOpenEliminarInspector(params.row?.inspector)} size="small" color="primary" >
                                <AssignmentTurnedInIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Asignar">
                            <IconButton onClick={() => handleOpenEliminarInspector(params.row?.inspector)} size="small" color="success" >
                                <GroupAddIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                );
            },
        },

    ];
    const verSolicitud=(data)=>{
        console.log('los datos de data es ', data)
        Swal.fire({
            title: "Visualizar Documentos",
            text: "Selecciona una opción:",
            icon: "question",
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "FC01",
            denyButtonText: "Servicio",
            cancelButtonText: "Cerrar",
          }).then(async (result)  => {
            if (result.isConfirmed) {
              const fileFetch = await fetch(host + `FC_01/servirAchivosGenerales/tabla=${'fc_01_documentos'}&nombreId=${'idfc01_solicitudregistro'}&idSolicitud=${data?.id}&idoficio=${6}`)

              if (fileFetch.status != 404) {
                  const blob = await fileFetch.blob();
                  const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                  window.open(url);
              } else {
                Swal.fire("Archivo no encontrado", "", "error");
              }
            } else if (result.isDenied) {
                const fileFetch = await fetch(host + `FC_01/servirAchivosGenerales/tabla=${'fc_01_documentos'}&nombreId=${'idfc01_solicitudregistro'}&idSolicitud=${data?.id}&idoficio=${4}`)

              if (fileFetch.status != 404) {
                  const blob = await fileFetch.blob();
                  const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                  window.open(url);
              } else {
                Swal.fire("Archivo no encontrado", "", "error");
              }
            } 
          });
    }

    React.useEffect(() => {
        dispatch(getAllSolicitudesACUI({
            status: 4,
            tipo: 'fc_09_solicitudemicioncertificadonomexportacionyentregahologram',
            skip: page * pageSize,
            take: pageSize,
        })).then((res) => {
            console.log('los datos de res es ', res)
            const data = res?.payload?.data?.data?.solicitudes || [];
            setTotal(res?.payload?.data?.data?.total || 0);
            const formattedRows = data.map(anexo => {
                let estatus = '';
                /*if (anexo?.solicitudesuifc01.length === 0) estatus = 'Sin Asignar';
                if (anexo?.solicitudesuifc01?.[0]?.statusdelasolicitud === 1) estatus = 'Asignada inspector';
                if (anexo?.solicitudesuifc01?.[0]?.statusdelasolicitud === 2) estatus = 'Pendiente Inspección';
                if (anexo?.solicitudesuifc01?.[0]?.statusdelasolicitud === 3) estatus = 'Informe revisión';
                if (anexo?.solicitudesuifc01?.[0]?.statusdelasolicitud === 4) estatus = 'Solicitud atendida';*/
                const revisor = anexo?.solicitudesuifc01?.length > 0
                    ? `${anexo?.solicitudesuifc01[0]?.inspector?.nombre} ${anexo?.solicitudesuifc01[0]?.inspector?.apellidos}`
                    : '';
                return {
                    id: anexo?.idfc09_solicitudcertificado,
                    nombre: anexo?.nombrecliente,
                    folio: anexo?.folio,
                    socio: anexo?.numerosocio,
                    estatus,
                    revisor
                };
            });
            setRows(formattedRows);
        });
    }, [page, pageSize]);

    return (
        <Fragment >
            <div className="col-12 ms-3 text-center">
                <div style={{ height: 660, width: "100%", color: "black" }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        pagination
                        paginationMode="server"
                        rowCount={total}
                        onPageChange={(newPage) => setPage(newPage)}
                        page={page}
                        rowsPerPageOptions={[10, 20, 50]}
                        components={{
                            Toolbar: QuickSearchToolbar,
                        }}
                        sx={{
                            boxShadow: 0,
                            color: "black",
                            border: 0,
                            "& .MuiDataGrid-cell": {
                                display: "block",
                                position: "relative",
                                textAlign: "center",
                            },
                        }}
                    />

                </div>
            </div>
        </Fragment>

    );
}

export default withRouter(SolicitudFC09UIComponent)